import type { NextPage } from 'next'
import { MdOutlineArrowRight } from 'react-icons/md'

import { Card } from 'src/components/atoms/Card'
import { Heading2Display, Subtitle } from 'src/components/atoms/Typography'
import {
  FullWidthContainer,
  FullWidthContainerBackgroundColor
} from 'src/components/layouts/Container'
import { Page } from 'src/components/layouts/Page'
import BlogPosts from 'src/components/molecules/BlogPosts/BlogPosts'
import { BlogPostBackgroundColor } from 'src/components/molecules/BlogPosts/types'
import { CallToActionButtonLink } from 'src/components/molecules/CallToActionButtonLink'

import { blogPath } from 'src/config/paths'
import { trpc } from 'src/utils/trpc'

import { FundersTab } from './FundersTab'

const Leaderboards: NextPage = () => {
  const { data: funderStories } = trpc.useQuery([
    'sanity.getPosts',
    { category: 'funder-stories', year: 'all', limit: 3 }
  ])

  return (
    <Page
      title='Leaderboard'
      subtitleComponent={
        <>
          <Subtitle className='font-medium'>
            Fund future forests to restore and protect New Zealand Aotearoa’s
            biodiversity and ecosystem resilience.
          </Subtitle>
          <Subtitle className='font-medium'>
            Join funders leading the way in making a positive nature impact.
          </Subtitle>
        </>
      }
      heroImage='/img/leaderboard.png'
      showHero
      isFullWidth
    >
      <FullWidthContainer
        backgroundColor={FullWidthContainerBackgroundColor.linen}
      >
        <Card size='small'>
          <FundersTab />
        </Card>
      </FullWidthContainer>
      <FullWidthContainer
        backgroundColor={FullWidthContainerBackgroundColor.white}
      >
        <Heading2Display className='text-center'>
          Funder stories
        </Heading2Display>
        <BlogPosts
          posts={funderStories?.data}
          backgroundColor={BlogPostBackgroundColor.white}
        />
        <div className='text-center pt-4'>
          <CallToActionButtonLink
            href={blogPath({
              queryParams: {
                category: 'funder-stories'
              }
            })}
          >
            Read more
            <MdOutlineArrowRight size={30} />
          </CallToActionButtonLink>
        </div>
      </FullWidthContainer>
    </Page>
  )
}

export default Leaderboards
